import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import axios from 'axios';
// import Select from 'react-dropdown-select';
import Select from 'react-select';
import AddBoardModal from './AddBoard/AddBoard';
import AddColumnModal from './AddBoard/AddColumnModal';
import AddAutoMation from './Automation/Automation';
import Automations from './Automation/Automations';
import services from '../services';
import { boardLocal } from '../utils/LocalSt';
import { useSelector } from 'react-redux';
import { HiArchiveBox } from 'react-icons/hi2';
import { toast } from 'react-toastify';
import ConfirmationPopup from './ConfirmationPopup';
import { useDispatch } from 'react-redux';
import { changeBoradTab, setEmailStatus, setWhatsAppStatus, toggleDate, toggleTable } from '../Redux/slice';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Notification from './notification/Notification';
import { getAllDateTableTask } from '../Redux/GetSlice';
import { Button, Menu, MenuItem, Tooltip } from '@mui/material';
import AllAutomation from './Automation/AllAutomation';
const Header = ({
    filterList,
    emailName,
    handleChange,
    handleSelectedBoard,
    setSelectedBoardId,
    handleAddColumn,
    selectedBoardId,
    selectedEmailsIds,
    role,
    setSelectedBoard,
    selectedBoard,
    getTaskMailIndbox,
    columns,
    getAllBoard,
    boardName,
    setBoardName,
    getTaskMail,
    activeButton,
    setActiveButton,
    setTaskMail
}) => {
    const [boardStatus, setBoardStatus] = useState(false);
    const [columnAddStatus, setColumnAddStatus] = useState(false);
    const [deleteShowBox, setDeleteShowBox] = useState(false);
    const [automtStatus, setAutomtStatus] = useState(false);
    const [deleteItem, setDeleteItem] = useState('');
    const navigate = useNavigate();
    const [hasArchiveAccess, setHasArchiveAccess] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const dispatch = useDispatch();
    const selectedTab = useSelector((state) => state?.redux?.selectedTab);
    const columnCall = useSelector((state) => state.redux.AddColumnCall);
    const valueTab = selectedTab === 'GMAIL' ? 0 : 1;
    const [step, setStep] = useState(1);
    const [editId, setEditId] = useState(null);
    const [isOpenDeadline, setIsOpenDeadline] = useState(false);
    const deadlineDropdownRef = useRef(null);

    const handleClick = (button) => {

        setActiveButton(button);
        if (button === 'board') {
            navigate('/app');
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));
            // getTaskMail();
        } else if (button === 'date') {
            const data = {
                boardId: selectedBoardId,
            };

            dispatch(getAllDateTableTask({ data }));
            dispatch(toggleDate(true));
            dispatch(toggleTable(false));
            // navigate('/dateplan');
            // navigate('/tabledata');
        } else if (button === 'table') {
            dispatch(toggleTable(true));
            dispatch(toggleDate(false));
            // getTaskMail();
            // navigate('/tabledata');
        }
    };
    const handleUser = () => {
        navigate('/user');
    };

    const [isLogoutUser, setIsLogoutUser] = useState(false);
    const [automations, setAutomations] = useState(false);

    const getButtonClass = (button) =>
        `p-[7px] ${activeButton === button ? 'bg-[#20212414]' : 'bg-white'
        } mr-[5px] items-center flex cursor-pointer text-black gap-[4px] rounded-[5px]`;

    const filterdropdown = () => {
        setIsOpenDeadline(!isOpenDeadline);
    };

    const logoutdropdown = () => {
        setIsLogoutUser(!isLogoutUser);
    };

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('userData');
        axios.defaults.headers.common['Authorization'] = '';
        localStorage.clear('');
        window.location.replace('/login');
        // window.parent.postMessage({ type: 'LOGOUT' }, 'http://localhost:5173');
    };

    const handleAutomation = () => { };

    // useEffect(() => {
    //     columnCall && setColumnAddStatus(false);
    // }, [columnCall]);

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('userData'));
        if (role === 'admin') {
            setHasArchiveAccess(true);
        } else if (userData && userData.isPermission) {
            setHasArchiveAccess(true);
        }
        columnCall && setColumnAddStatus(false);
    }, [columnCall, boardName, role]);

    const handleDelete = async () => {
        try {
            await services.board.DELETE_BOARD(deleteItem);
            toast.success('Board Delete Successfully...');
            setDeleteItem('');
            setDeleteShowBox(false);
            getAllBoard();
        } catch (error) {
            console.error(error);
        }
    };
    const handleChangeTab = (event, newValue) => {
        const tab = newValue === 0 ? 'GMAIL' : 'WHATSAPP';
        dispatch(changeBoradTab(tab));
    };

    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleSelect = (type) => {
        if (type === 'gmail') {
            dispatch(setEmailStatus(true));
        } else if (type === 'whatsapp') {
            dispatch(setWhatsAppStatus(true));
        }
        handleCloseMenu();
    };

    useEffect(() => {
        if (!isOpenDeadline) return;
        function handleClickOutside(event) {
            if (deadlineDropdownRef.current && !deadlineDropdownRef.current.contains(event.target)) {
                setIsOpenDeadline(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenDeadline]);


    useEffect(() => {
        if (activeButton == "board") {
            navigate('/app')
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));
            getTaskMail()
        }

    }, [activeButton, selectedBoardId])
    return (
        <>
            <div className="header-app flex justify-between items-center">
                {role === 'admin' && (
                    <>
                        <div style={{ display: 'flex', minWidth: '300px', maxWidth: '358px' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <div className="w-[359px] flex items-center">
                                    <div
                                        className={`custom-tab-label ${valueTab === 0 ? 'active' : ''}`}
                                        onClick={(e) => handleChangeTab(e, 0)}
                                        style={{
                                            flex: 1,
                                            textAlign: 'center',
                                            padding: '12px 0',
                                            cursor: 'pointer',
                                            borderBottom:
                                                valueTab === 0 ? '2px solid rgb(1, 87, 155)' : '2px solid transparent',
                                            fontWeight: valueTab === 0 ? 'bold' : 'normal',
                                            color: valueTab === 0 ? 'rgb(1, 87, 155)' : '#000',
                                        }}
                                    >
                                        Gmail
                                    </div>
                                    <div
                                        className={`custom-tab-label ${valueTab === 1 ? 'active' : ''}`}
                                        onClick={(e) => handleChangeTab(e, 1)}
                                        style={{
                                            flex: 1,
                                            textAlign: 'center',
                                            padding: '12px 0',
                                            cursor: 'pointer',
                                            borderBottom:
                                                valueTab === 1 ? '2px solid rgb(1, 87, 155)' : '2px solid transparent',
                                            fontWeight: valueTab === 1 ? 'bold' : 'normal',
                                            color: valueTab === 1 ? 'rgb(1, 87, 155)' : '#000',
                                        }}
                                    >
                                        Whatsapp
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div className="header-item flex items-center justify-center" style={{ flex: 1, gap: '20px' }}>
                    <div className="flex gap-2">
                        {role == 'admin' || (boardName && boardName.length > 0 && selectedBoard) ? (
                            <>
                                <div onClick={() => handleClick('board')} className={getButtonClass('board')}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="13"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-filter-right rotate-[0deg]"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5m0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5" />
                                    </svg>
                                    <span className="text-[11.2px] custom-tab-label">Board</span>
                                </div>
                                <div onClick={() => handleClick('table')} className={getButtonClass('table')}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-calendar2-range"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                        <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zM9 8a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1m-8 2h4a1 1 0 1 1 0 2H1z" />
                                    </svg>
                                    <button className="text-[11.2px] custom-tab-label">Table</button>
                                </div>
                                <div onClick={() => handleClick('date')} className={getButtonClass('date')}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-calendar3-event"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                        <path d="M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                    </svg>
                                    <button className="text-[11.2px] custom-tab-label">Date</button>
                                </div>
                            </>
                        ) : (
                            <div className="text-sm text-gray-500">No board assigned</div>
                        )}

                        <div className=" text-[black] flex items-center">
                            <div onClick={logoutdropdown} className={`${isLogoutUser ? 'block' : 'hidden'}`}>
                                <div className="layout-backdrop"></div>
                                <div
                                    className={`dropdown !absolute ${isLogoutUser ? 'open' : ''
                                        } deadline-day deadend-start-w move-bottom kanban-dropDown border-2 border-[#F5F5F5] text-black`}
                                    style={{ right: '23px', top: '50px' }}
                                >
                                    <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => {
                                            handleSelect('gmail');
                                            setIsOpenDeadline(false);
                                        }}
                                    >
                                        <button className=" text-black text-[12px]"> Add to gmail</button>
                                    </div>
                                    <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => {
                                            handleSelect('whatsapp');
                                            setIsOpenDeadline(false);
                                        }}
                                    >
                                        <button className=" text-black text-[12px]">Add to whatsapp</button>
                                    </div>

                                    <div onClick={() => setBoardStatus(true)}>
                                        <span className=" text-black text-[12px]">Add Board</span>
                                    </div>

                                    <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => navigate('/template')}
                                    >
                                        <button className=" text-black text-[12px]">Template</button>
                                    </div>
                                    <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => navigate('/usermanage')}
                                    >
                                        <button className=" text-black text-[12px]">User management</button>
                                    </div>

                                    <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => navigate('/draft')}
                                    >
                                        <button className=" text-black text-[12px]">Draft</button>
                                    </div>

                                    {/* <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => navigate('/group')}
                                    >
                                        <button className=" text-black text-[12px]">Group</button>
                                    </div> */}

                                    {/* <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => navigate('/permissions')}
                                    >
                                        <button className=" text-black text-[12px]">Permissions</button>
                                    </div> */}

                                    <div style={{ display: 'flex' }}>
                                        <div
                                            className="rounded-[4px] hover:bg-[#f3f3f3]"
                                            onClick={() => navigate('/automations')}
                                        >
                                            <button className=" text-black text-[12px]">
                                                {/* <img src="assets/eye.svg" alt="eye" style={{ marginTop: '6px' }} /> */}
                                            </button>
                                        </div>
                                        <div
                                            className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        // style={{ marginLeft: '10px' }}
                                        >
                                            <button
                                                onClick={() => setAutomations(!automations)}
                                                className=" text-black text-[12px]"
                                            >
                                                Add Automations
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div style={{ display: 'flex', marginLeft: '100px' }}>
                    <div style={{ width: '300px' }}>
                        <Select
                            style={{ width: '300px' }}
                            options={boardName}
                            onChange={(e) => {
                                setSelectedBoardId(e?.value);
                                handleSelectedBoard(e);
                                setSelectedBoard(e);
                            }}
                            value={selectedBoard}
                            components={{
                                Option: ({ data, innerRef, innerProps }) => (
                                    <div
                                        ref={innerRef}
                                        {...innerProps}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '5px',
                                        }}
                                    >
                                        <span>{data.label}</span>
                                        <HiArchiveBox
                                            style={{ cursor: 'pointer' }}
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent triggering `onChange`
                                                setDeleteShowBox(true);
                                                setDeleteItem(data?.value);
                                            }}
                                        />
                                    </div>
                                ),
                            }}
                        />
                    </div>
                </div> */}
                {/* <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-search mr-[25px]"
                        viewBox="0 0 16 16"
                    >
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                    </svg>
                </div> */}

                <div className="d-flex " style={{ gap: '15px' }}>
                    {(role === 'admin' || (boardName && boardName.length > 0)) && (
                        <div>
                            <div
                                style={{
                                    width: '150px',
                                    border: '1px solid lightgrey',
                                    borderRadius: '4px',
                                }}
                                onClick={() => setIsOpenDeadline(false)}
                            >
                                {(() => {
                                    const options = boardName ? [...boardName] : [];
                                    if (hasArchiveAccess) {
                                        options.unshift({ label: 'Archive', value: 'archived' });
                                    }
                                    return (
                                        <Select
                                            className="cursor-pointer"
                                            style={{ width: '150px' }}
                                            options={options}
                                            onChange={(e) => {
                                                if (e.value === 'archived') {
                                                    navigate('/archivedboard');
                                                    setSelectedBoard(e);
                                                    return;
                                                }
                                                setSelectedBoardId(e?.value);
                                                localStorage.setItem('boardId', e?.value);
                                                handleSelectedBoard(e);
                                                setSelectedBoard(e);
                                                setIsOpenDeadline(false);

                                                setBoardName((prev) => {
                                                    const rest = prev.filter((b) => b.value !== e.value);
                                                    return [e, ...rest];
                                                });
                                            }}
                                            value={selectedBoard}
                                            components={{
                                                Option: ({ data, innerRef, innerProps }) => (
                                                    <div
                                                        ref={innerRef}
                                                        {...innerProps}
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: '5px',
                                                        }}
                                                    >
                                                        <span>{data.label}</span>
                                                    </div>
                                                ),
                                            }}
                                        />
                                    );
                                })()}
                            </div>
                        </div>
                    )}

                    {/* <Box
                        sx={{
                            width: '45%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            position: 'relative',
                        }}
                    >
                        <button
                            style={{
                                padding: '8px 16px',
                                borderRadius: '6px',
                                minWidth: 50,
                                color: 'white',
                                fontWeight: '500',
                                fontSize: '14px',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '6px',
                                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                backgroundColor: '#01579b',
                            }}
                            onClick={() => setIsOpenDeadline(!isOpenDeadline)}
                        >
                            Add
                        </button>
                        {isOpenDeadline && (
                            <div
                                ref={deadlineDropdownRef}
                                style={{
                                    position: 'absolute',
                                    top: '110%',
                                    right: '0',
                                    background: 'white',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                    zIndex: 10,
                                    minWidth: 120,
                                }}
                            >
                                <div
                                    style={{
                                        padding: '8px',
                                        cursor: 'pointer',
                                        fontFamily: 'inherit',
                                        fontWeight: '600',
                                    }}
                                    onClick={() => {
                                        handleSelect('gmail');
                                        setIsOpenDeadline(false);
                                    }}
                                    className=" text-black text-[12px]"
                                >
                                    Add to gmail
                                </div>
                                <div
                                    style={{
                                        padding: '8px',
                                        cursor: 'pointer',
                                        fontFamily: 'inherit',
                                        fontWeight: '600',
                                    }}
                                    onClick={() => {
                                        handleSelect('whatsapp');
                                        setIsOpenDeadline(false);
                                    }}
                                    className=" text-black text-[12px]"
                                >
                                    Add to whatsapp
                                </div>
                            </div>
                        )}
                    </Box> */}
                    {/* <div className="flex items-center gap-4">
                        <Tooltip title="Notifications" placement="top-end">
                            {/* <button
                                onClick={() => {
                                    setIsNotificationOpen(!isNotificationOpen), setIsOpenDeadline(false);
                                }}
                                className="p-[4px] hover:bg-gray-100 rounded-full"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-bell"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
                                </svg>
                                  </Tooltip>
                    </div> */}
                </div>

                <div className="flex items-center gap-4">
                    <div className="flex flex-col items-center mx-2">
                        {/* <Tooltip title="Settings" placement="top-end"> */}
                        {role == 'admin' && (
                            <div
                                className="flex items-center justify-center border border-blue-400 rounded-lg"
                                onClick={() => {
                                    logoutdropdown(), setIsOpenDeadline(false);
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-gear"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
                                    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
                                </svg>
                            </div>
                        )}
                        {/* </Tooltip> */}
                    </div>
                </div>
            </div>
            {boardStatus && (
                <AddBoardModal
                    show={boardStatus}
                    onHide={() => setBoardStatus(false)}
                    getAllBoard={getAllBoard}
                    setBoardName={setBoardName}
                />
            )}
            {columnAddStatus && (
                <AddColumnModal
                    show={columnAddStatus}
                    onHide={() => setColumnAddStatus(false)}
                    handleAddColumn={handleAutomation}
                />
            )}
            {automtStatus && (
                <AddAutoMation
                    show={automtStatus}
                    onHide={() => setAutomtStatus(false)}
                    handleAddColumn={handleAutomation}
                    selectedBoard={selectedBoard}
                    getTaskMailIndbox={getTaskMailIndbox}
                />
            )}
            <div>
                {automations && step === 1 && (
                    <AllAutomation
                        show={automations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        step={step}
                        setStep={setStep}
                        setAutomations={setAutomations}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
                {automations && step === 2 && (
                    <Automations
                        show={automations}
                        setAutomations={setAutomations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        boardName={boardName}
                        gmailUsers={filterList}
                        step={step}
                        setStep={setStep}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
            </div>{' '}
            {deleteShowBox && (
                <ConfirmationPopup
                    taskToDeleteId={''}
                    onCancel={() => {
                        setDeleteShowBox(false);
                    }}
                    deleteTaskMail={handleDelete}
                />
            )}
            {<Notification isNotificationOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} />}
        </>
    );
};

export default Header;
